
      import DoubleList from './double-list.vue'
      import type { App, Plugin } from 'vue'

      export const DoubleListPlugin: Plugin = {
        install(app: App) {
          app.component('DoubleList', DoubleList)
        },
      }
      export { DoubleList }
      